import {z} from 'zod';

export const chatSettingsSchema = z.object({
  conversationSessionTimeoutHours: z.number(),
  welcomeMessageTemplateId: z.string().nullable(),
});
export const getChatSettingsApiArgSchema = z.void();
export const putChatSettingsApiArgSchema = z.object({
  chatSettingsRequestBody: chatSettingsSchema,
});
export const messageChannelTypeEnumSchema = z.enum(['chat', 'whatsapp']);
export const getMessageChannelResponseBodySchema = z.object({
  messageChannelType: messageChannelTypeEnumSchema,
});
export const setMessageChannelRequestBodySchema = z.object({
  messageChannelType: messageChannelTypeEnumSchema,
});
export const getBusinessCaseMessageChannelApiArgSchema = z.object({
  businessCaseId: z.string(),
});
export const setBusinessCaseMessageChannelApiArgSchema = z.object({
  businessCaseId: z.string(),
  setMessageChannelRequestBody: setMessageChannelRequestBodySchema,
});
export const getInterestMessageChannelApiArgSchema = z.object({
  interestId: z.string(),
});
export const setInterestMessageChannelApiArgSchema = z.object({
  interestId: z.string(),
  setMessageChannelRequestBody: setMessageChannelRequestBodySchema,
});
export const subscribeToChatConversationApiArgSchema = z.object({
  conversationId: z.string(),
});
export const unsubscribeFromChatConversationApiArgSchema = z.object({
  conversationId: z.string(),
});

// Message channel
export type MessageChannelTypeEnum = z.infer<typeof messageChannelTypeEnumSchema>;
export type GetMessageChannelResponseBody = z.infer<typeof getMessageChannelResponseBodySchema>;
export type SetMessageChannelRequestBody = z.infer<typeof setMessageChannelRequestBodySchema>;

// Business case message channel
export type GetBusinessCaseMessageChannelApiResponse = GetMessageChannelResponseBody;
export type GetBusinessCaseMessageChannelApiArg = z.infer<
  typeof getBusinessCaseMessageChannelApiArgSchema
>;
export type SetBusinessCaseMessageChannelApiResponse = void;
export type SetBusinessCaseMessageChannelApiArg = z.infer<
  typeof setBusinessCaseMessageChannelApiArgSchema
>;

// Interest message channel
export type GetInterestMessageChannelApiResponse = GetMessageChannelResponseBody;
export type GetInterestMessageChannelApiArg = z.infer<typeof getInterestMessageChannelApiArgSchema>;
export type SetInterestMessageChannelApiResponse = void;
export type SetInterestMessageChannelApiArg = z.infer<typeof setInterestMessageChannelApiArgSchema>;

// Chat settigns
export type ChatSettingsRequestBody = z.infer<typeof chatSettingsSchema>;
export type ChatSettingsResponseBody = z.infer<typeof chatSettingsSchema>;
export type GetChatSettingsApiArg = z.infer<typeof getChatSettingsApiArgSchema>;
export type GetChatSettingsApiResponse = ChatSettingsResponseBody;
export type PutChatSettingsApiResponse = void;
export type PutChatSettingsApiArg = z.infer<typeof putChatSettingsApiArgSchema>;

// Chat conversation subscription
export type SubscribeToChatConversationApiResponse = unknown;
export type SubscribeToChatConversationApiArg = z.infer<
  typeof subscribeToChatConversationApiArgSchema
>;
export type UnsubscribeFromChatConversationApiResponse = unknown;
export type UnsubscribeFromChatConversationApiArg = z.infer<
  typeof unsubscribeFromChatConversationApiArgSchema
>;
